import { NetworkNodeType } from "../../../../poly/NodeContext";
const POST_PROCESS_PARAM_OPTIONS = {
  callback: (node) => {
  }
};
import { ParamConfig } from "../../../utils/params/ParamsConfig";
export function CameraPostProcessParamConfig(Base) {
  return class Mixin extends Base {
    constructor() {
      super(...arguments);
      this.doPostProcess = ParamConfig.BOOLEAN(0);
      this.postProcessNode = ParamConfig.NODE_PATH("", {
        visibleIf: {
          doPostProcess: 1
        },
        nodeSelection: {
          types: [NetworkNodeType.POST]
        },
        ...POST_PROCESS_PARAM_OPTIONS
      });
    }
  };
}
